<template>
  <modal
    @before-close="modalClose"
    @before-open="modalOpen"
    :name="`${modal}${prefix}`"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    :width="800"
  >
  <div class="shadow-wrapper" @click="closeModal"></div>
    <card v-if="model">
      <div class="add-control">
        <p-button class="btn-sm mr-2 btn-icon" round @click.native.prevent="closeModal">
          <span class="ti-arrow-left"></span>
          <span>Назад</span>
        </p-button>
        <p-button  class="btn-sm " type="info" @click.native.prevent="accept">Применить</p-button>
      </div>

      <hr/>

      <list
        :columns="model.columns"
        :modalCreate="model.modalCreate"
        :removeLink="model.removeLink"
        :cardLink="model.cardLink"
        :isUpdate="model.isUpdate"
        :params="p"
        :isAdd="model.isAdd"
        :itemLink="model.itemLink"
        :setLink="model.setLink"
        :openItem="model.openItem"
        :fields="model.fields"
        :searchDisable="model.searchDisable"
        v-model="val"
        :simple="simple"
      />


        <hr/>
         <div class="add-control">
      
        <p-button class="btn-sm mr-2 btn-icon" round @click.native.prevent="closeModal">
          <span class="ti-arrow-left"></span>
          <span>Назад</span>
        </p-button>
        <p-button  class="btn-sm " type="info" @click.native.prevent="accept">Применить</p-button>
      </div>

      
    </card>
  </modal>
</template>
<script>
import List from "../List";

export default {
  name: "ListItem",
  data() {
    return {
      val: [],
      p:{}
    };
  },
  props: {
    modal: {
      default: function () {
        return "";
      },
    },
    params: {
      default: function(){
        return null;
      },
    },
    prefix: {
      default: function () {
        return "";
      },
    },
    simple: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.$store.state.modals[this.modal];
      },
    },
  },
  mounted(){
    
  },
  created() {
    this.val = this.value;
    this.p = (this.model.params) ? this.model.params : this.params;
    if(Object.keys(this.params).length)
      this.p = {...this.p, ...this.params}
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  components: {
    List,
  },
  methods: {
    modalClose() {},
    modalOpen() {},
    closeModal() {
      this.$modal.hide(`${this.modal}${this.prefix}`);
    },
    accept() {
      if (this.val) {
        this.$modal.hide(`${this.modal}${this.prefix}`);
        this.$emit("input", this.val);
       // this.val = [];
      }
    },
  },
};
</script>

<style lang="scss">
.add-control {
  


}
</style>